export const actionTypes = {
  SET_INSURANCE_INFO_IS_LOADING: 'MEMBER_PORTAL/SET_INSURANCE_INFO_IS_LOADING',
  FETCH_INSURANCE_INFO: 'MEMBER_PORTAL/FETCH_INSURANCE_INFO',
  UPDATE_INSURANCE_INFO: 'MEMBER_PORTAL/UPDATE_INSURANCE_INFO',
  RESET_INSURANCE_INFO: 'MEMBER_PORTAL/RESET_INSURANCE_INFO',
};
